(function (root) {
  'use strict';
  const money = value => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD',maximumFractionDigits:0}).format(value);
  const priceRange = (min,max) => min===max ? money(max) : `${money(min)}–${money(max)}`;
  function addAttribution(fields,url) {
    for(const key of ['utm_source','utm_medium','utm_campaign','utm_term','utm_content']) {
      const value=url.searchParams.get(key)?.trim();
      if(value) fields[key]=value.slice(0,200);
    }
  }

  function buildPayload({contact,state,quote,sizeLabel,pageUrl,submittedAt}) {
    const url=new URL(pageUrl);
    const fields={
      'Shopping tool':'HVAC system finder',
      'Pricing path':state.path==='rebate'?'HEAR rebate':'Promotional',
      'Equipment setup':state.unit==='package'?'Package unit':state.unit==='split'?'Split system':'To confirm',
      'Heating type':state.heat==='gas'?'Gas furnace + A/C':state.heat==='electric'?'Heat pump':'To confirm',
      'Sizing chart answer':sizeLabel,
      'Estimated capacity':state.size==='unknown'?'To confirm':`${state.size} tons`,
      'System option':state.system?quote.system.name:'Not selected yet',
      'Electric utility':state.utilityProvider.toUpperCase(),
      'Regular installed estimate':money(quote.regular),
      'Promotional discount estimate':money(quote.promotion),
      'HEAR rebate estimate':money(quote.instant),
      'Happy Home Club member discount estimate':money(quote.member),
      'Transparent price discount estimate':money(quote.transparent),
      'Utility rebate estimate':quote.utilityStatus==='calculated'?priceRange(quote.utility,quote.utilityMax):money(0),
      'Price after estimated savings':priceRange(quote.dueMin,quote.due),
    };
    addAttribution(fields,url);
    return {source:'reeis.com',formProvider:'is_opts',formId:'reeis-hvac-shopping-tool-v1',serviceBucket:'rebate',
      pageUrl:url.origin+url.pathname,name:contact.name,phone:contact.phone,email:contact.email,fields,submittedAt};
  }

  function buildInterestPayload({contact,state,sizeLabel,pageUrl,submittedAt}) {
    const url=new URL(pageUrl);
    const fields={
      'Shopping tool':'HVAC system finder',
      'Request type':'Packaged gas rebate interest list',
      'Equipment setup':'Package unit',
      'Heating type':'Gas furnace + A/C',
      'Sizing chart answer':sizeLabel,
      'Estimated capacity':state.size==='unknown'?'To confirm':`${state.size} tons`,
      'Follow-up request':'Contact when Arizona provides guidance on packaged gas rebate processing',
    };
    addAttribution(fields,url);
    return {source:'reeis.com',formProvider:'is_opts',formId:'reeis-hvac-shopping-tool-v1',serviceBucket:'rebate',
      pageUrl:url.origin+url.pathname,name:contact.name,phone:contact.phone,email:contact.email,fields,submittedAt};
  }

  const api={buildPayload,buildInterestPayload};
  if(typeof module!=='undefined') module.exports=api;
  else root.ReeisLeadIntake=api;
})(typeof window!=='undefined'?window:globalThis);
